import { TextCaption } from '@carboncopyco/ui';
import type React from 'react';

export interface InputFieldProps {
  label: string | React.ReactNode;
  name: string;
  error?: React.ReactNode;
  children: React.ReactNode;
}

export const InputField = ({
  label,
  name,
  error,
  children,
}: InputFieldProps) => {
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={name}>
        <TextCaption
          label={label}
          color="text-ds-natural-600"
        />
      </label>
      {children}
      {error && (
        <span className="text-ds-danger-400 font-ds-inter text-ds-200 font-ds-light tracking-ds-tight leading-ds-200">
          {error}
        </span>
      )}
    </div>
  );
};
